import React from "react";
import { motion } from "framer-motion";
import ResumeCard from "./ResumeCard";

const Education = () => {
  return (
    <motion.div
      initial={{ opacity: 0 }}
      animate={{ opacity: 1, transition: { duration: 0.5 } }}
      className="w-full flex flex-col lgl:flex-row gap-10 lgl:gap-20"
    >
      {/* part one */}
      <div>
        <div className="py-6 lgl:py-12 font-titleFont flex flex-col gap-4">
          <p className="text-sm text-designColor tracking-[4px]">
            2022 - Present
          </p>
          <h2 className="text-3xl md:text-4xl font-bold">Work Experience</h2>
        </div>
        <div className="mt-6 lgl:mt-14 w-full h-[auto] py-10 border-l-[6px] border-l-black border-opacity-30 flex flex-col gap-10">
          <ResumeCard
            title="Full Stack Developer Intern"
            subTitle="Simplium Technologies - (Dec 2024 - Present)"
            result="Pune"
            des="Enhanced 'MyDigiCardManager' platform by improving user interfaces with React.js and optimizing backend performance using Node.js and MongoDB."
          />
          <ResumeCard
            title="Freelance Full Stack Developer"
            subTitle="Self-Employed - (Nov 2023 - Present)"
            result="Remote"
            des="Delivered custom web solutions for diverse clients, utilizing React.js for dynamic front-end development and Node.js with MongoDB for efficient back-end operations. Successfully managed multiple projects, ensuring timely delivery and client satisfaction."
          />
        </div>
      </div>
      {/* part Two */}
      <div>
        <div className="py-6 lgl:py-12 font-titleFont flex flex-col gap-4">
          <p className="text-sm text-designColor tracking-[4px]">
            2008 - Present
          </p>
          <h2 className="text-3xl md:text-4xl font-bold">Education Quality</h2>
        </div>
        <div className="mt-6 lgl:mt-14 w-full h-[auto] py-10 border-l-[6px] border-l-black border-opacity-30 flex flex-col gap-10">
          <ResumeCard
            title="BE in Computer Science"
            subTitle="Dr. D Y Patil Institute of Engineering Management and Research"
            result="9.25/10"
            des="Pursuing a Bachelor of Engineering in Computer Engineering at DYPIEMR. Currently focusing on advanced topics such as Data Structures, Software Engineering, and Computer Networks."
          />
          <ResumeCard
            title="Secondary Education"
            subTitle="Bhartya Heavy Electric Limited Secondary School"
            result="94.8/100"
            des="Completed secondary education with a focus on science and mathematics, achieving a score of 94.8%."
          />
        </div>
      </div>
    </motion.div>
  );
};

export default Education;
